import React from 'react';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  cookieAlert: {
    '& .MuiAlert-icon': {
      fontSize: 20,
      color: '#6200EE',
    },
    background: 'rgba(98, 0, 238, 0.08)',

    '& .MuiAlertTitle-root': {
      color: '#6200EE',
    },
    color: 'black',
  },
});

function Index(props) {
  const { severity, children } = props;
  const classes = useStyles();
  return (
    <Alert className={classes.cookieAlert} severity={severity}>
      {children}
    </Alert>
  );
}

export default Index;
